// import cookie from "react-cookies";

export const bearerAuthOptions = {
	// headers: {
	// 	Authorization: `Bearer ${cookie.load("WIC_EDTRACKER_LEARNER_ACCESS")}`,
	// },
};

export const basicAuthOptions = {
	headers: {
		Authorization:
			"Basic ZXE4UTcwTHU1QkxPR1FmT2lSS3Z0djI2WEc4WFdLMWo6SUxBV0dwbWZhMmRQT204aHBENmNyWXdiT2pIVThaa29Fd3B0",
	},
};



// WEBPACK FOOTER //
// ./src/api/util.js